/*
 * @Author: libo 
 * @Date: 2020-11-13 17:26:14 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2022-08-24 10:50:14
 */

<!--补水界面-->
<template>
  <a-modal
    :title="$t('操作')"
    :width="1000"
    :ok=false
    :visible="visible"
    :confirmLoading="confirmLoading"
    :okButtonProps="{ props: {disabled: disableSubmit} }"
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="$t('关闭')">
    <template slot="footer">
      <a-button key="close" @click="handleCancel">
        {{ $t('关闭') }}
      </a-button>
    </template>
    <meter-replenishment-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit"></meter-replenishment-form>
    <a-spin :spinning="confirmLoading">
      <j-form-container :disabled="formDisabled">
        <a-form :form="form" slot="detail" :colon="false">
          <div>
            <a-tabs v-model="activeKey" @change="changeTab">
              <a-tab-pane key="1" :tab="$t('补水')">
                <div class="form-contain">
                  <a-divider orientation="left">{{ $t('用户信息') }}</a-divider>
                    <detail-list>
                      <detail-list-item :term="$t('用户编号')">{{model.userId}}</detail-list-item>
                      <detail-list-item :term="$t('用户姓名')">{{model.userName}}</detail-list-item>
                      <detail-list-item :term="$t('手机号码')">{{model.userPhone}}</detail-list-item>
                      <detail-list-item :term="$t('表编号')">{{model.meterId}}</detail-list-item>
                      <detail-list-item :term="$t('用户地址')">{{model.userAddr}}</detail-list-item>
                      <detail-list-item :term="$t('用水单价(元)')">{{userByKeyId.userPriceTotal}}</detail-list-item>
                      <detail-list-item :term="$t('价格名称')">{{userByKeyId.userPriceName}}</detail-list-item>
                      <detail-list-item :term="$t('单次最大购买金额(元)')">{{userByKeyId.maxBuyOnce}}</detail-list-item>
                      <detail-list-item :term="$t('最大囤积金额(元)')">{{userByKeyId.maxHording}}</detail-list-item>
                      <detail-list-item :term="$t('用户余额(元)')">
                        <a-tag color="cyan" style="font-size: 14px;padding: 5px">
                          {{userByKeyId.userAccountNum}}
                        </a-tag>
                      </detail-list-item>
                      <detail-list-item :term="$t('结算累计流量(m³)')">{{userByKeyId.userTotalUse}}</detail-list-item>
                    </detail-list>
                  <div>
                  <a-divider orientation="left">{{ $t('用户补水信息') }}</a-divider>
                    <a-row :gutter="16">
                      <a-col :span="9">
                        <a-form-item class="a-form-model-item-row" :label="$t('订单编号')" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 0px">
                          <a-input v-model="userByKeyId.orderId" style="width: 100%;" :readOnly="true" class="background"></a-input>
                        </a-form-item>
                      </a-col>
                      <a-col :span="12">
                        <a-button type="primary" :ghost="true" style="margin-top:5px;" @click="Refresh()">
                          {{ $t('刷新') }}
                        </a-button>
                      </a-col>
                    </a-row>  
                    <a-row :gutter="[8,8]">
                      <a-col :span="8">
                        <a-form-item :label="$t('交易方式')" style="width:100%;margin-bottom: 0px">
                          <a-radio-group  v-decorator="['payWay',validatorRules.payWay]">
                            <a-radio value="1">
                              {{ $t('营业厅现金') }}
                            </a-radio>
                          </a-radio-group>
                        </a-form-item>
                      </a-col>
                      <a-col :span="8" >
                        <a-form-item :label="$t('计费类型')" style="width:100%;margin-bottom: 0px">
                          <a-radio-group v-decorator="['payType',validatorRules.payType]" @change="handleChange">
                            <a-radio :value="1">
                              {{ $t('按金额') }}
                            </a-radio>
                            <a-radio :value="2">
                              {{ $t('按吨数') }}
                            </a-radio>
                          </a-radio-group>
                        </a-form-item>
                      </a-col>
                    </a-row>
                    <a-row :gutter="[8,8]">
                      <div v-if="thebillingtype==2">
                        <a-col :span="8" >
                          <a-form-item :label="$t('交易吨数(吨)')">
                            <a-input v-decorator="['buyWaterCount',validatorRules.buyWaterCount]" @blur="buyWaterCount" :placeholder="$t('请输入交易吨数')"></a-input> 
                          </a-form-item>
                        </a-col>
                        <a-col :span="6">
                          <a-form-item label=" "> 
                          <a-button v-for="item in itemList" :key="item.key" class="money-choose-btn"  @click="Capacity(item.value)" style="margin-left: 10px;">
                          {{item.value}}t
                          </a-button>
                          </a-form-item>
                        </a-col>
                      </div>
                      <div v-if="thebillingtype==1">
                        <a-col :span="8" >
                          <a-form-item :label="$t('补水金额(元)')">
                            <a-input v-decorator="['userTotalPayNum',validatorRules.userTotalPayNum]" @blur="userTotalPayNum" :placeholder="$t('请输入补水金额')"></a-input>
                          </a-form-item>
                        </a-col>
                        <a-col :span="6">
                          <a-form-item label=" "> 
                          <a-button v-for="item in payList" :key="item.key" class="money-choose-btn"  @click="amountofmoney(item.value)" style="margin-right: 10px;">
                          ¥{{item.value}}
                          </a-button>
                          </a-form-item>
                        </a-col>
                      </div>
                      <a-col :span="8" v-show="false">
                        <a-form-item :label="$t('实际补水金额(元)')">
                          <a-input v-decorator="['buyWaterMoney']" :readOnly="true" class="background"></a-input>
                        </a-form-item>
                      </a-col>
                      <a-col :span="8">
                        <a-form-item :label="$t('交易吨数(m³)')">
                          <a-input v-decorator="['tradingTonnage']" :readOnly="true" class="background"></a-input>
                        </a-form-item>
                      </a-col>
                      <a-col :span="22">
                        <a-form-item :label="$t('补水备注')">
                          <a-textarea v-decorator="['remark']" :row="2" :placeholder="$t('请输入补水备注')" />
                        </a-form-item>
                      </a-col>
                    </a-row>
                    <a-row>
                      <a-col :span="7">
                      </a-col>
                      <a-col :span="8">
                        <a-button type="danger" block size="large" @click="submitForm">
                          {{ $t('补水') }}
                        </a-button>
                      </a-col>
                    </a-row>
                  </div> 
                </div>              
              </a-tab-pane>
              <a-tab-pane key="2" :tab="$t('补水记录')">
                <div class="form-contain">
                  <a-table 
                  :columns="columns"
                  :data-source="data"
                  rowKey='id'
                  size='middle'
                  :scroll="{ x: true }"
                  :pagination="ipagination"
                  @change="handleTableChange"
                  >
                    <span slot="userPriceSlot" slot-scope="text, record">
                      <span v-if="record.userPriceName"> {{record.userPriceName}}({{record.userPriceTotal?record.userPriceTotal + $t('元'): '--'}})</span>
                      <span v-else>--</span>
                    </span>
                  </a-table>
                </div>
              </a-tab-pane>
            </a-tabs>
          </div>
        </a-form>
      </j-form-container>
  </a-spin>
  </a-modal>
</template>

<script>
  import { httpAction, getAction,putAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import {isUndefined} from'@/utils/validate'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import DetailList from '@/components/tools/DetailList'
  import {payWayObj,payTypeObj} from '@/utils/constants/commonConstant'
  const DetailListItem = DetailList.Item
  const data = [];
  export default {
    name: 'MeterReplenishmentForm',
    components: {
      JFormContainer,
      DetailList,
      DetailListItem,
      // isUndefined
    },
    Userinfolist:[],
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        data,
        treeData:[],
        phoneWarning:'',
        title:this.$t("操作"),
        seen:false,
        visible: false,
        condition:true,
        disableSubmit:false,
        userByKeyId:{},
        Userinfolist:[],
        activeKey:'1',
        form: this.$form.createForm(this),
        model: {},
        ject:{},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        ipagination:{
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + "-" + range[1] + " " + this.$t('共{total}条', { total: total })
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
        },
        confirmLoading: false,
        payList:[   //定义paylist列表
          {key:1, value:20},
          {key:2, value:50},
          {key:3, value:100}
        ],
        itemList:[  //定义itemlist列表
          {key:1, value:10},
          {key:2, value:50},
          {key:3, value:100}
        ],
        url: {
          add: "/jeecg-charge/meter/meterUserinfo/add",
          edit: "/jeecg-charge/meter/meterUserinfo/edit",
          queryById: "/jeecg-charge/meter/meterUserinfo/queryById",
          doPayTask:"/jeecg-charge/meter/userPay/doPayTask",
          userByKeyId:"/jeecg-charge/meter/userPay/queryUserByKeyId",  //补水前查询接口
          doFreePayTask:"/jeecg-charge/meter/userPay/doFreePayTask" ,  //补水接口
          doFreeApplyPayTask: "/auditprocess/auditRecord/doFreeApplyPayTask",
          UserRecordList:"/jeecg-charge/meter/meterUserPayRecord/list", //缴费记录查询接口
        },
        thebillingtype: 1,
        realpay:0,
      }
    },
    computed: {
      // i18n：列标题/校验消息使用 computed 以响应语言切换
      columns() {
        return [
          {
            title: this.$t('用户姓名'),
            dataIndex: 'userName',
            align:'center'
          },{
            title: this.$t('购买金额(元)'),
            dataIndex: 'userPayAccountNum',
            align:'center'
          },{
            title: this.$t('缴费途径'),
            dataIndex: 'payWay',
            align:'center',
            customRender:(t,r,index) => {
              if(isUndefined(payWayObj[t])) {
                return this.$t('其他')
              }
              return this.$t(payWayObj[t])
            }
          },{
            title: this.$t('价格信息'),
            dataIndex: 'userPrice',
            align:'center',
            scopedSlots: { customRender: 'userPriceSlot' },
          },{
            title: this.$t('补水量(吨)'),
            dataIndex: 'payWaterNum',
            align:'center'
          },{
            title: this.$t('订单号'),
            dataIndex: 'payOrderId',
            align:'center'
          },{
            title: this.$t('操作员'),
            dataIndex: 'createBy',
            align:'center'
          },{
            title: this.$t('充值日期'),
            dataIndex: 'createTime',
            align:'center'
          },{
            title: this.$t('剩余金额(元)'),
            dataIndex: 'userNowAccountNum',
            align: 'center'
          },{
            title: this.$t('备注'),
            dataIndex: 'payRemark',
            align:'center'
          },{
            title:this.$t('操作类型'),
            dataIndex:'userAccountPayType',
            fixed:"right",
            align:'center',
            customRender:(t,r,index) => {
              if(isUndefined(payTypeObj[t])) {
                return this.$t('其他')
              }
              return this.$t(payTypeObj[t])
            }
          },
        ];
      },
      // i18n：校验消息使用 computed 以响应语言切换
      validatorRules() {
        return {
          payType:{
          initialValue:1
          },
          payWay:{
          initialValue:'1',
          rules:[{}]
          },
          buyWaterCount:{  //交易吨数
          rules:[
            { required: true, message: this.$t('请输入交易吨数') },
            {required: false,pattern: /^[1-9]\d*$/,message: this.$t('交易吨数有误，请重新输入')}
          ]
          },
          userTotalPayNum: { //补水金额
          rules:[
            { required:true, message: this.$t('请输入补水金额')},
            {required: false,pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/,message: this.$t('补水金额输入有误，请重新输入')}
            ]
          },
          buyWaterMoney:{  //实际付款金额
          rules:[{required:true, message: this.$t('请输入实际付款金额')}]
          },
        }
      },
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
    },
    methods: {
      handleTableChange(pagination, filters, sorter) {
        if (Object.keys(sorter).length > 0) {
          this.isorter.column = sorter.field;
          this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
        }
        this.ipagination = pagination;
        this.queryUserRecordList();
      },
      add() {
        this.edit({});
      },
      edit (record) { 
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        console.log(this.model);
        this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model,))
        })
        this.queryUserByKeyId(record);
      },
      queryUserRecordList() {  //缴费记录查询
        let params = {}
        params.pageNo = this.ipagination.current;
        params.pageSize = this.ipagination.pageSize;
        params.userKeyId = this.model.id;
        params.userAccountPayType = 3;
        getAction(this.url.UserRecordList, params).then((res) => {
          if(res.success){
           this.data = res.result.records;
           this.ipagination.total = res.result.total;
           console.log(res.result.records);
           console.log(this.ipagination.total);
          }
        })
      },
      queryUserByKeyId(record) {  //补水前查询
        let params = {}
        params.id = record.id
        console.log(params.id);
        putAction(this.url.userByKeyId, params).then((res) => {
          console.log(res);
          if(res.success){
            
           this.userByKeyId = res.result;
           console.log(this.userByKeyId);
          }
        })
      },
      handleOk(){},
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            // that.confirmLoading = true;
            let httpurl = '';
            let method = 'put';
            if(this.model.sysOrgCode == 'A29') {
              // 和静县的有补水审核
              httpurl+=this.url.doFreeApplyPayTask;
            }else{
              httpurl+=this.url.doFreePayTask;
            }
            let formData = Object.assign(this.userByKeyId,values)
            formData.userKeyId = this.model.id
            formData.userId = this.model.userId
            formData.meterId = this.model.meterId
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                console.log(res.message);
                setTimeout(() => {
                  this.visible = false;
                  this.shut();
                  that.$emit('ok');
                },400)
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              this.thebillingtype=1
              this.form.resetFields();
            })
          }
        })
      },
      userTotalPayNum(e) {   
        //补水金额
        let userTotalPayNum = this.form.getFieldValue('userTotalPayNum')
        if(userTotalPayNum==0){
          const h = this.$createElement;
          this.$info({
            title: this.$t('信息'),
            content: h('div', {}, [
              h('p', this.$t('补水金额不能为0，请重新输入！')),
            ]),
            onOk() {},
          });
          this.form.resetFields();
        }else if (parseFloat(userTotalPayNum) > parseFloat(this.userByKeyId.maxBuyOnce)) {
          const h = this.$createElement;
          this.$info({
            title: this.$t('信息'),
            content: h('div', {}, [
              h('p', this.$t('补水金额超过用户单次购买最大金额{amount},请重新输入!', { amount: this.userByKeyId.maxBuyOnce })),
            ]),
            onOk() {},
          });
          this.form.resetFields(['userTotalPayNum','buyWaterMoney'])
        }else if ((parseFloat(userTotalPayNum)+parseFloat(this.userByKeyId.userAccountNum)) > parseFloat(this.userByKeyId.maxHording)) {
          const h = this.$createElement;
          this.$info({
            title: this.$t('信息'),
            content: h('div', {}, [
              h('p', this.$t('补水余额超过用户囤积金额{amount},请重新输入!', { amount: this.userByKeyId.maxHording })),
            ]),
            onOk() {},
          });
          this.form.resetFields(['userTotalPayNum','buyWaterMoney'])
        } else if(userTotalPayNum != undefined){
          this.form.setFieldsValue({
          'buyWaterMoney': userTotalPayNum,    // 充值金额的值给应收金额  
          'tradingTonnage': (userTotalPayNum / this.userByKeyId.userPriceTotal).toFixed(2) // 交易吨数 
        });
        // this.form.setFieldsValue({
        //   'tradingTonnage': (userTotalPayNum / this.userByKeyId.userPriceTotal).toFixed(2) // 交易吨数 
        // });
        }
      },
      buyWaterCount(){  //交易吨数 
        if (this.form.getFieldValue('buyWaterMoney')) {
          this.form.setFieldsValue({
            'buyWaterMoney': ''   
          });
        }
        this.form.validateFields((err, values) => {
          if (!err) {
            let buyWaterCount  = this.form.getFieldValue('buyWaterCount')
          if(buyWaterCount==0){
            const h = this.$createElement;
            this.$info({
              title: this.$t('信息'),
              content: h('div', {}, [
                h('p', this.$t('交易吨数不能为0，请重新输入！')),
              ]),
              onOk() {},
            });
            this.form.resetFields();
          }else if ((parseFloat(buyWaterCount)*this.userByKeyId.userPriceTotal) > parseFloat(this.userByKeyId.maxBuyOnce)) {
                const h = this.$createElement;
                this.$info({
                  title: this.$t('信息'),
                  content: h('div', {}, [
                    h('p', this.$t('交易金额超过用户单次购买最大金额{amount},请重新输入!', { amount: this.userByKeyId.maxBuyOnce })),
                  ]),
                  onOk() {},
                });
                this.form.resetFields(['buyWaterCount','buyWaterMoney'])
              }else if ((parseFloat(buyWaterCount)*this.userByKeyId.userPriceTotal) > parseFloat(this.userByKeyId.maxHording)) {
                const h = this.$createElement;
                this.$info({
                  title: this.$t('信息'),
                  content: h('div', {}, [
                    h('p', this.$t('交易余额超过用户最大囤积值{amount},请重新输入!', { amount: this.userByKeyId.maxHording })),
                  ]),
                  onOk() {},
                });
                this.form.resetFields(['buyWaterCount','buyWaterMoney'])
              } else if(this.form.getFieldValue('buyWaterCount')!=undefined){
              this.form.setFieldsValue({
              'buyWaterMoney': (this.form.getFieldValue('buyWaterCount')*this.userByKeyId.userPriceTotal).toFixed(2)    //应收金额的值*单价
              });
            }
          }
        })  
      },
      handleChange(row) {   //计费类型点击事件
        this.thebillingtype = row.target.value
        this.form.resetFields();
        console.log(row); 
      },
      amountofmoney(value){  // 金额按钮点击事件
        console.log(value);
        this.form.setFieldsValue({
          'userTotalPayNum' : value,
          'buyWaterMoney' : value
        });
        this.userTotalPayNum();
      },
      Capacity(value) {    //交易吨数按钮点击
        this.form.setFieldsValue({
          'buyWaterCount' : value,
          'buyWaterMoney' : value*this.userByKeyId.userPriceTotal,
        })
        this.buyWaterCount();
      },
      shut(){
        this.activeKey = '1';
        this.thebillingtype = 1;
        this.form.resetFields();
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = true;
      },
      close () {
        this.$emit('close');
        this.disableSubmit = false;
        this.visible = false;
      },
      Refresh() {
        this.queryUserByKeyId(this.model)
      },
      changeTab(e) {
        if(this.activeKey == 2) {
          this.queryUserRecordList()
        }
      },
      handleCancel () {
        this.shut();
        this.close();
      }
    }
  }
</script>

<style scoped>
.ant-form-item >>> .ant-select{
  width: 100%;
}
.span {
  margin: 8px;
}
.background{
  background-color:rgb(238,238,238)
}
.detail-list >>> .content{
  line-height: normal;
}
.form-contain{
  height: 60vh;
  overflow-y: auto;
  overflow-x: hidden;
}
.form-contain >>> .ant-divider-inner-text{
  color: rgba(24,144,255,0.85);
  font-size: 16px;
}
</style>